import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CompanyContextService } from '@pages/empresas/services/company-context.service';

export const companyContextInterceptor: HttpInterceptorFn = (req, next) => {
  const companyContext = inject(CompanyContextService);
  const companyId = companyContext.getCompanyId();
  if (companyId === null) { return next(req); }
  return next(req.clone({ setHeaders: { 'X-Company-Id': String(companyId) } }));
};
